// extracted by mini-css-extract-plugin
export default {"darkMode":"App_darkMode__ijMly","lightMode":"App_lightMode__sDZoa"};